import { mapActions } from 'vuex';
import Events from '_utils/events';
import ResellerService from '_services/rest/modules/reseller';

export default {
  name: 'reseller-actions',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    blockAccess(reseller) {
      const status = (reseller.status === 1) ? 0 : 1;
      ResellerService.toggleAccess(reseller.id, status)
        .then(() => {
          this.$router.push({ name: 'admin-reseller-list', params: { page: 1 } });
          Events.$emit('update:pagination', { page: 1 });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      ResellerService.deleteReseller(this.selectReseller)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', { page: 1 });
          this.activeAlert({ message: 'Parceiro desabilitado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
